/* eslint-disable react/prop-types */
import { Chip, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { DATE_WINDOWS, MATCH_MODES } from "../utils/matchTransactions";

// Toolbar controls for how the reconcile button pairs entries
export default function MatchSettings({ value, onChange }) {
  const usesDate = MATCH_MODES.find((m) => m.value === value.mode)?.date;

  return (
    <>
      <FormControl sx={{ minWidth: 230 }} size="small">
        <InputLabel id="match-mode-label">Match by</InputLabel>
        <Select
          labelId="match-mode-label"
          id="match-mode"
          value={value.mode}
          label="Match by"
          onChange={(e) => onChange({ ...value, mode: e.target.value })}
        >
          {MATCH_MODES.map((m) => (
            <MenuItem key={m.value} value={m.value}>
              {m.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {usesDate && (
        <FormControl sx={{ minWidth: 150 }} size="small">
          <InputLabel id="match-window-label" shrink>Date window</InputLabel>
          <Select
            labelId="match-window-label"
            id="match-window"
            value={value.dateWindow ?? ""}
            label="Date window"
            onChange={(e) =>
              onChange({
                ...value,
                dateWindow:
                  e.target.value === "" ? null : Number(e.target.value),
              })
            }
            displayEmpty
            notched
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {DATE_WINDOWS.map((days) => (
              <MenuItem key={days} value={days}>
                {days === 0 ? "Same day" : `± ${days} day${days > 1 ? "s" : ""}`}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </>
  );
}

const STRENGTH_COLORS = {
  Strong: { color: "#135200", bg: "#d9f7be" },
  Medium: { color: "#614700", bg: "#fff1b8" },
  Weak: { color: "#820014", bg: "#ffccc7" },
};

// How alike the two sides of an automatic match are
export function MatchStrengthChip({ strength }) {
  if (!strength) return null;
  const c = STRENGTH_COLORS[strength];
  return (
    <Chip
      size="small"
      label={strength}
      sx={{
        ml: 0.75,
        height: 18,
        fontSize: 10.5,
        fontWeight: 700,
        color: c.color,
        bgcolor: c.bg,
      }}
    />
  );
}
